import config from '../../config';
import React from 'react';
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import styles from './Header.module.css'

import { getSession, deleteSession } from '../../utils';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      session: null
    };
  }

  async componentDidMount() {
    this.setState({
      session: getSession(),
    });
  }

  logOut = () => {
    deleteSession();
    this.setState({
      session: null,
    });
    window.location.replace('/');
  }

  render() {
    return (
      <Navbar fixed="top" bg="white" expand="md" className={styles.navbar}>
        <Navbar.Brand href={`${config.domains.marketing}/`}>
          <img alt="" src={`${config.assets_base_url}/reciprocity_trusts_logo.svg`} className="d-inline-block align-top"/>
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Nav className={styles.nav}>
            <Nav.Link href={`${config.domains.marketing}/how-reciprocity-works/`} className={styles.navMenu}>Get Started</Nav.Link>
            <Nav.Link href={`${config.domains.marketing}/impact/`} className={styles.navMenu}>What We Do</Nav.Link>
            <Nav.Link href={`${config.domains.marketing}/indigenous-governance/`} className={styles.navMenu}>Indigenous Governance</Nav.Link>
            <Nav.Link href={`${config.domains.marketing}/acts-of-reciprocity/`} className={styles.navMenu}>Learn</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;
